import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgClear(props: RootSvgProps) {
  return (
    <RootSvg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.0208 0.292672C13.4113 0.683196 13.4113 1.31636 13.0208 1.70689L8.07107 6.65663L13.0208 11.6064C13.4113 11.9969 13.4113 12.6301 13.0208 13.0206C12.6303 13.4111 11.9971 13.4111 11.6066 13.0206L6.65686 8.07085L1.70711 13.0206C1.31659 13.4111 0.683423 13.4111 0.292899 13.0206C-0.0976252 12.6301 -0.0976245 11.9969 0.292899 11.6064L5.24265 6.65663L0.292899 1.70689C-0.0976247 1.31636 -0.0976245 0.683196 0.292899 0.292672C0.683424 -0.0978527 1.31659 -0.0978524 1.70711 0.292672L6.65686 5.24242L11.6066 0.292672C11.9971 -0.0978523 12.6303 -0.0978521 13.0208 0.292672Z"
        fill="#6E6E6E"
      />
    </RootSvg>
  );
}
